"use client";

// Figma node 1824:6915 — Mock App UI (full screen OTT app)
// Thumbnail assets sourced from alright-admin.rumbleapp.gg widget endpoints
import { c as _c } from "react/compiler-runtime";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { BottomNavbar } from "./BottomNavbar";
import { trackAnalyticsEvent } from "@/lib/analytics";
const SPOTLIGHT = [{
  title: "Dil Se Dil Tak",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/Dil%20Se%20Dil%20Tak%20copy%20(1)-1767692391928.jpg"
}, {
  title: "Don Of Jaunpur",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16@2x-1771572433124.webp"
}, {
  title: "Dhokha-E-Ishq",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16-1770483724464.webp"
}, {
  title: "Risk Wala Ishq",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16%20(6)%20(1)-1770298033565.webp"
}, {
  title: "Dabangg Bodyguard",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16@2x-1772627365811.webp"
}, {
  title: "Dil Ki Adalat",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16@2x-1771999429230.webp"
}, {
  title: "Shaadi By Mistake",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16%20WL-1770188303793.webp"
}, {
  title: "Band Baaja Billionaire",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9_16%20(1)-1769686357491.webp"
}, {
  title: "Tiger",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16@2x%20(3)-1773209312649.webp"
}];
const RECOMMENDED = [{
  title: "Band Baaja Billionaire",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9_16%20(1)-1769686357491.webp"
}, {
  title: "Race Against Time",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16@2x%20(2)%20(1)-1772781432969.webp"
}, {
  title: "Chehra Ya Naqab?",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16%20(3)%20(1)-1769777928148.webp"
}, {
  title: "Senior se Pyaar",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/Senior%20Se%20Pyaar-1768413328482.png"
}, {
  title: "Humari Adhoori Kahani",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/ChatGPT%20Image%20Feb%206,%202026,%2006_40_24%20PM-1770391037889.webp"
}, {
  title: "Dil Se Dil Tak",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/Dil%20Se%20Dil%20Tak%20copy%20(1)-1767692391928.jpg"
}, {
  title: "Maa, Beta aur Millionaire Doctor",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/Maa,%20Beta%20aur%20Millionaire%20Doctor-1764581403130.jpg"
}, {
  title: "Rickshawala Officer",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16%20(7)-1770990506424.webp"
}, {
  title: "Mohalle Wala Pyaar",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16%20(1)%20(1)-1769754007061.webp"
}, {
  title: "Inspector Romeo",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16@2x%20(7)-1774606850743.webp"
}];
const PREMIUM_ORIGINALS = [{
  title: "Senior se Pyaar",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/Senior%20Se%20Pyaar-1768413328482.png"
}, {
  title: "Mohalle Wala Pyaar",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16%20(1)%20(1)-1769754007061.webp"
}, {
  title: "Delhi vs. Mumbai S2",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/DVM%20S2%20copy-1759295933131.jpg"
}, {
  title: "School Friends",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16-2.jpg%20(1)-1769601793886.webp"
}, {
  title: "The Sarkari Karyalay S2",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/The%20Sarkari%20Karyalay%20S2%20copy-1759931793675.jpg"
}, {
  title: "Perfect Parents",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/WhatsApp%20Image%202026-01-07%20at%205.33.57%20PM%20(1)-1767793255908.jpeg"
}, {
  title: "Saving Mr. CEO",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/Saving%20Mr.%20CEO%20..-1763634539178.jpg"
}, {
  title: "The Wrong Moonlight",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/The%20wrong%20moonlight_01%20(1)-1765805353179.jpg"
}, {
  title: "Mayajaal",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/IMG_8569%20(2)-1768807320491.png"
}, {
  title: "Pati Se Revenge",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/Pati%20se%20Revenge%209_16-1768488916870.png"
}];
const MOST_WATCHED = [{
  title: "Don Of Jaunpur",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16@2x-1771572433124.webp"
}, {
  title: "Dhokha-E-Ishq",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16-1770483724464.webp"
}, {
  title: "Risk Wala Ishq",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16%20(6)%20(1)-1770298033565.webp"
}, {
  title: "Shaadi By Mistake",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16%20WL-1770188303793.webp"
}, {
  title: "Boss ka Comeback",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16%20(4)%20(1)-1770110548357.webp"
}, {
  title: "Maa, Beta aur Hidden CEO",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16%20(2)%20(1)-1769775535086.webp"
}, {
  title: "Pyaar Ka Price Tag",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/Pyaar%20ka%20Price%20Tag%20.-1764223418752-1767095588512.jpg"
}, {
  title: "Band Baaja Billionaire",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9_16%20(1)-1769686357491.webp"
}, {
  title: "Maa, Beti aur Missing Papa",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/WhatsApp%20Image%202026-01-09%20at%206.42.38%20PM-1767967393454.jpeg"
}, {
  title: "Baazigar Ka Badla",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16%20(1)-1771408471043.webp"
}];
const NEW_RELEASES = [{
  title: "Border Wala Pyaar",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16@2x%20(8)-1774609840182.webp"
}, {
  title: "Inspector Romeo",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16@2x%20(7)-1774606850743.webp"
}, {
  title: "Zero Se Hero",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16@2x%20(5)-1773389915242.webp"
}, {
  title: "Dabangg Bodyguard",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16@2x-1772627365811.webp"
}, {
  title: "Don Of Jaunpur",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16@2x-1771572433124.webp"
}, {
  title: "Dhokha-E-Ishq",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16-1770483724464.webp"
}, {
  title: "Risk Wala Ishq",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16%20(6)%20(1)-1770298033565.webp"
}, {
  title: "Shaadi By Mistake",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16%20WL-1770188303793.webp"
}, {
  title: "Laathi",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16-1770976446300.webp"
}, {
  title: "Love To Hate You",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16@2x%20(8)%20(1)-1773838720731.webp"
}, {
  title: "Dil Ki Adalat",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16@2x-1771999429230.webp"
}];
const GLOBAL_SHOWS = [{
  title: "Maa, Beta aur Hidden CEO",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/9X16%20(2)%20(1)-1769775535086.webp"
}, {
  title: "Maa, Beti aur Missing Papa",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/WhatsApp%20Image%202026-01-09%20at%206.42.38%20PM-1767967393454.jpeg"
}, {
  title: "Saving Mr. CEO",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/Saving%20Mr.%20CEO%20..-1763634539178.jpg"
}, {
  title: "The Wrong Moonlight",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/The%20wrong%20moonlight_01%20(1)-1765805353179.jpg"
}, {
  title: "Our Love is The Ocean of Stars",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/Our%20Love%20is%20the%20Ocean%20of%20Stars%20copy-1763445546009.jpg"
}, {
  title: "CEO ka Grand Return: Part 2",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/CEO%20KA%20GRAND%20RETURN%20_V1-1764591975928.jpg"
}, {
  title: "Secret Affair with Bodyguard",
  src: "https://alright-bhc8d2fyatfrexca.z02.azurefd.net/alright/seriesThumbnail/Crushing%20on%20My%20Bodyguard%20....-1763634471493.jpg"
}];

// ── Analytics state (module-level to survive remounts) ──────────────────────
const SCREEN_NAMES = ['home_popular', 'home_new_hot', 'home_originals', 'home_global'] as const;
const TAB_LABELS = ['Popular', 'New & Hot', 'Originals', 'Global'] as const;
const impressionsSeen = new Set<string>();
const nudgeImpressionsSeen = new Set<string>();
let lastScreenName = 'subscription_page';
let currentTab = 0;
export function resetMockAppAnalytics() {
  impressionsSeen.clear();
  nudgeImpressionsSeen.clear();
  lastScreenName = 'subscription_page';
  currentTab = 0;
}
interface WidgetAnalytics {
  placement_tab: string;
  widget_title: string;
  widget_type: string;
  widget_order: number;
}
interface ContentAnalyticsMeta {
  [key: string]: unknown;
  content_name: string;
  screen_name: string;
  placement_tab: string;
  widget_title: string;
  widget_type: string;
  widget_order: number;
  content_order: number;
}
function useContentImpression(ref, analyticsMeta) {
  const $ = _c(5);
  const impressionKey = analyticsMeta ? `${analyticsMeta.placement_tab}|${analyticsMeta.widget_title}|${analyticsMeta.content_order}` : "";
  let t0;
  let t1;
  if ($[0] !== analyticsMeta || $[1] !== impressionKey || $[2] !== ref) {
    t0 = () => {
      if (!impressionKey || !analyticsMeta || impressionsSeen.has(impressionKey)) {
        return;
      }
      const el = ref.current;
      if (!el) {
        return;
      }
      const observer = new IntersectionObserver(t2 => {
        const [entry] = t2;
        if (entry.isIntersecting && !impressionsSeen.has(impressionKey)) {
          impressionsSeen.add(impressionKey);
          trackAnalyticsEvent("CONTENT_IMPRESSION_WEB", analyticsMeta);
          observer.disconnect();
        }
      }, {
        threshold: 0.5
      });
      observer.observe(el);
      return () => observer.disconnect();
    };
    t1 = [impressionKey, ref, analyticsMeta];
    $[0] = analyticsMeta;
    $[1] = impressionKey;
    $[2] = ref;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
}

// ── Components ──────────────────────────────────────────────────────────────

interface MockAppUIProps {
  onThumbnailClick: () => void;
}
function ShowCard(t0) {
  const $ = _c(10);
  const {
    src,
    title,
    onClick,
    analyticsMeta
  } = t0;
  const ref = useRef(null);
  useContentImpression(ref, analyticsMeta);
  let t1;
  if ($[0] !== analyticsMeta || $[1] !== onClick) {
    t1 = () => {
      if (analyticsMeta) {
        trackAnalyticsEvent("CONTENT_CLICKED_WEB", analyticsMeta);
      }
      onClick();
    };
    $[0] = analyticsMeta;
    $[1] = onClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleClick = t1;
  let t2;
  if ($[3] !== src || $[4] !== title) {
    t2 = <img src={src} alt={title} className="w-full aspect-[2/3] object-cover block" draggable={false} />;
    $[3] = src;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute inset-0 rounded-[4px] pointer-events-none" style={{
      padding: "2px",
      background: "linear-gradient(180deg, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0.25) 20%, rgba(0,0,0,0) 32%, rgba(0,0,0,0) 68%, rgba(255,255,255,0.25) 80%, rgba(255,255,255,0.25) 100%)",
      WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
      WebkitMaskComposite: "destination-out",
      maskComposite: "exclude"
    }} />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== handleClick || $[8] !== t2) {
    t4 = <button ref={ref} onClick={handleClick} className="relative block w-full rounded-[4px] overflow-hidden">{t2}{t3}</button>;
    $[7] = handleClick;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function SectionHeader(t0) {
  const $ = _c(2);
  const {
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h2 className="h-[26px] flex items-center text-white text-[14px] font-semibold px-4 leading-none">{title}</h2>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function ShowGrid(t0) {
  const $ = _c(4);
  const {
    shows,
    onClick,
    analytics
  } = t0;
  let t1;
  if ($[0] !== analytics || $[1] !== onClick || $[2] !== shows) {
    const top = shows.slice(0, 9);
    const rows = [];
    for (let i = 0; i < top.length; i = i + 3, i) {
      rows.push(top.slice(i, i + 3));
    }
    t1 = <>{rows.map((row, ri) => <div key={ri} className={`grid gap-[6px] px-4${ri > 0 ? " mt-[6px]" : ""}`} style={{
        gridTemplateColumns: `repeat(${row.length}, minmax(0, 1fr))`
      }}>{row.map((show, i_0) => {
          const contentOrder = ri * 3 + i_0;
          return <ShowCard key={i_0} src={show.src} title={show.title} onClick={onClick} analyticsMeta={analytics ? {
            content_name: show.title,
            screen_name: "Home",
            placement_tab: analytics.placement_tab,
            widget_title: analytics.widget_title,
            widget_type: analytics.widget_type,
            widget_order: analytics.widget_order,
            content_order: contentOrder
          } : undefined} />;
        })}</div>)}</>;
    $[0] = analytics;
    $[1] = onClick;
    $[2] = shows;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}

// Figma node 1824:6943 — Spotlight carousel (cover-flow style, circular, swipeable)
function SpotlightCarousel(t0) {
  const $ = _c(54);
  const {
    shows,
    onActiveClick,
    containerHeight,
    contentWidth,
    analytics
  } = t0;
  const [active, setActive] = useState(0);
  const touchStartX = useRef(null);
  const n = shows.length;
  let t1;
  if ($[0] !== n || $[1] !== shows) {
    t1 = i => shows[(i % n + n) % n];
    $[0] = n;
    $[1] = shows;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const get = t1;
  let t2;
  if ($[3] !== n) {
    t2 = delta => setActive(prev => ((prev + delta) % n + n) % n);
    $[3] = n;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const navigate = t2;
  let t3;
  let t4;
  if ($[5] !== active || $[6] !== analytics || $[7] !== shows) {
    t3 = () => {
      if (!analytics) {
        return;
      }
      const show = shows[active];
      const key = `${analytics.placement_tab}|${analytics.widget_title}|${active}`;
      if (impressionsSeen.has(key)) {
        return;
      }
      impressionsSeen.add(key);
      trackAnalyticsEvent("CONTENT_IMPRESSION_WEB", {
        content_name: show.title,
        screen_name: "Home",
        placement_tab: analytics.placement_tab,
        widget_title: analytics.widget_title,
        widget_type: analytics.widget_type,
        widget_order: analytics.widget_order,
        content_order: active
      });
    };
    t4 = [active, analytics, shows];
    $[5] = active;
    $[6] = analytics;
    $[7] = shows;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  const activeCardH = Math.max(containerHeight - 38, 60);
  let t5;
  if ($[10] !== activeCardH) {
    t5 = Math.round(activeCardH * 2 / 3);
    $[10] = activeCardH;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== contentWidth) {
    t6 = Math.round(contentWidth * 0.62);
    $[12] = contentWidth;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const activeCardW = Math.min(t5, t6);
  let t10;
  let t11;
  let t12;
  let t13;
  let t7;
  let t8;
  let t9;
  if ($[14] !== active || $[15] !== activeCardH || $[16] !== activeCardW || $[17] !== analytics || $[18] !== containerHeight || $[19] !== get || $[20] !== navigate || $[21] !== onActiveClick) {
    const inactiveCardH = Math.round(activeCardH * 0.87);
    const inactiveCardW = Math.round(inactiveCardH * 2 / 3);
    const slots = [{
      offset: -2
    }, {
      offset: -1
    }, {
      offset: 0
    }, {
      offset: 1
    }, {
      offset: 2
    }];
    t12 = "pt-3 pb-2";
    if ($[29] !== containerHeight) {
      t13 = {
        height: containerHeight
      };
      $[29] = containerHeight;
      $[30] = t13;
    } else {
      t13 = $[30];
    }
    t9 = "overflow-hidden";
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = e => {
        e.stopPropagation();
        touchStartX.current = e.touches[0].clientX;
      };
      $[31] = t10;
    } else {
      t10 = $[31];
    }
    if ($[32] !== navigate) {
      t11 = e_0 => {
        e_0.stopPropagation();
        if (touchStartX.current === null) {
          return;
        }
        const delta_0 = e_0.changedTouches[0].clientX - touchStartX.current;
        if (delta_0 < -50) {
          navigate(1);
        } else {
          if (delta_0 > 50) {
            navigate(-1);
          }
        }
        touchStartX.current = null;
      };
      $[32] = navigate;
      $[33] = t11;
    } else {
      t11 = $[33];
    }
    t7 = "flex gap-[10px] items-center justify-center px-[44px]";
    t8 = slots.map(t14 => {
      const {
        offset
      } = t14;
      const show_0 = get(active + offset);
      const isActive = offset === 0;
      return <button key={offset} onClick={() => {
        if (isActive) {
          if (analytics) {
            trackAnalyticsEvent("CONTENT_CLICKED_WEB", {
              content_name: show_0.title,
              screen_name: "Home",
              placement_tab: analytics.placement_tab,
              widget_title: analytics.widget_title,
              widget_type: analytics.widget_type,
              widget_order: analytics.widget_order,
              content_order: active
            });
          }
          onActiveClick();
        } else {
          navigate(offset);
        }
      }} className="flex-shrink-0 relative rounded-[12px] overflow-hidden transition-all duration-300" style={{
        width: isActive ? activeCardW : inactiveCardW,
        height: isActive ? activeCardH : inactiveCardH
      }}><img src={show_0.src} alt={show_0.title} className="w-full h-full object-cover block" draggable={false} />{!isActive && <div className="absolute inset-0 bg-gradient-to-b from-transparent from-[52%] to-black/60 rounded-[12px]" />}<div className="absolute inset-0 rounded-[12px] pointer-events-none" style={{
          padding: "2px",
          background: isActive ? "linear-gradient(180deg, rgba(255,167,0,0.5) 0%, rgba(255,167,0,0.5) 20%, rgba(0,0,0,0) 32%, rgba(0,0,0,0) 68%, rgba(255,167,0,0.5) 80%, rgba(255,167,0,0.5) 100%)" : "linear-gradient(180deg, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0.25) 20%, rgba(0,0,0,0) 32%, rgba(0,0,0,0) 68%, rgba(255,255,255,0.25) 80%, rgba(255,255,255,0.25) 100%)",
          WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
          WebkitMaskComposite: "destination-out",
          maskComposite: "exclude"
        }} /></button>;
    });
    $[14] = active;
    $[15] = activeCardH;
    $[16] = activeCardW;
    $[17] = analytics;
    $[18] = containerHeight;
    $[19] = get;
    $[20] = navigate;
    $[21] = onActiveClick;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
    $[25] = t13;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
  } else {
    t10 = $[22];
    t11 = $[23];
    t12 = $[24];
    t13 = $[25];
    t7 = $[26];
    t8 = $[27];
    t9 = $[28];
  }
  let t14;
  if ($[34] !== t7 || $[35] !== t8) {
    t14 = <div className={t7}>{t8}</div>;
    $[34] = t7;
    $[35] = t8;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t10 || $[38] !== t11 || $[39] !== t14 || $[40] !== t9) {
    t15 = <div className={t9} onTouchStart={t10} onTouchEnd={t11}>{t14}</div>;
    $[37] = t10;
    $[38] = t11;
    $[39] = t14;
    $[40] = t9;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== active || $[43] !== shows) {
    let t17;
    if ($[45] !== active) {
      t17 = (_, i_0) => <button key={i_0} onClick={() => setActive(i_0)} className={`h-[6px] rounded-full transition-all duration-300 ${i_0 === active ? "w-[20px] bg-gradient-to-b from-[#ffba27] from-[18%] to-[#ffa700] to-[97%]" : "w-[6px] bg-[rgba(198,194,193,0.3)]"}`} />;
      $[45] = active;
      $[46] = t17;
    } else {
      t17 = $[46];
    }
    t16 = shows.map(t17);
    $[42] = active;
    $[43] = shows;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[47] !== t16) {
    t17 = <div className="flex items-center justify-center gap-[4px] mt-3">{t16}</div>;
    $[47] = t16;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  let t18;
  if ($[49] !== t12 || $[50] !== t13 || $[51] !== t15 || $[52] !== t17) {
    t18 = <div className={t12} style={t13}>{t15}{t17}</div>;
    $[49] = t12;
    $[50] = t13;
    $[51] = t15;
    $[52] = t17;
    $[53] = t18;
  } else {
    t18 = $[53];
  }
  return t18;
}

// ── Shared sections (reused across tabs) ──────────────────────────────────

// Figma node 1824:7083 — ranked 3×3 grid with gradient overlay + views badge
function MostWatchedCard(t0) {
  const $ = _c(21);
  const {
    show,
    rank,
    showRank,
    onClick,
    analyticsMeta
  } = t0;
  const ref = useRef(null);
  useContentImpression(ref, analyticsMeta);
  let t1;
  if ($[0] !== analyticsMeta || $[1] !== onClick) {
    t1 = () => {
      if (analyticsMeta) {
        trackAnalyticsEvent("CONTENT_CLICKED_WEB", analyticsMeta);
      }
      onClick();
    };
    $[0] = analyticsMeta;
    $[1] = onClick;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleClick = t1;
  let t2;
  if ($[3] !== show.src || $[4] !== show.title) {
    t2 = <img src={show.src} alt={show.title} className="absolute inset-0 w-full h-full object-cover" draggable={false} />;
    $[3] = show.src;
    $[4] = show.title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="absolute inset-0" style={{
      background: "linear-gradient(0deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0) 33%, rgba(0,0,0,0) 61%, rgba(0,0,0,0.75) 100%)"
    }} />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2) {
    t4 = <div className="absolute inset-0 rounded-[4px] overflow-hidden">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute inset-0 rounded-[4px] pointer-events-none" style={{
      padding: "2px",
      background: "linear-gradient(180deg, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0.25) 20%, rgba(0,0,0,0) 32%, rgba(0,0,0,0) 68%, rgba(255,255,255,0.25) 80%, rgba(255,255,255,0.25) 100%)",
      WebkitMask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
      WebkitMaskComposite: "destination-out",
      maskComposite: "exclude"
    }} />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== rank || $[11] !== showRank) {
    t6 = showRank && <span className="absolute select-none" style={{
      top: "5.71px",
      left: "4px",
      width: "24px",
      fontFamily: "Inter, sans-serif",
      fontWeight: 600,
      fontSize: "32px",
      lineHeight: "1.5em",
      textAlign: "center",
      background: "linear-gradient(180deg, rgba(150,150,150,0.85) 0%, rgba(255,255,255,1) 59%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      backgroundClip: "text"
    }}>{rank}</span>;
    $[10] = rank;
    $[11] = showRank;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      top: "86.5%",
      bottom: "3.68%",
      left: "1.83%",
      right: "1.83%"
    };
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="absolute flex items-center justify-end px-[6px]" style={t7}><div className="flex items-center gap-[4px] shrink-0"><img src="https://www.figma.com/api/mcp/asset/1051a8b9-1a12-4f99-a279-1b85e2c2420d" alt="" className="block w-[10px] h-[10px] max-w-none" /><span style={{
          fontFamily: "Inter, sans-serif",
          fontWeight: 500,
          fontSize: "10px",
          lineHeight: "15px",
          color: "#FFFFFF",
          width: "27px",
          textAlign: "center"
        }}>2.5Cr</span></div></div>;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t6) {
    t9 = <div className="relative w-full aspect-[2/3]">{t4}{t5}{t6}{t8}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== handleClick || $[19] !== t9) {
    t10 = <button ref={ref} onClick={handleClick} className="relative block w-full">{t9}</button>;
    $[18] = handleClick;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}
function MostWatchedGrid(t0) {
  const $ = _c(5);
  const {
    shows,
    onClick,
    showRank: t1,
    analytics
  } = t0;
  const showRank = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== analytics || $[1] !== onClick || $[2] !== showRank || $[3] !== shows) {
    const top9 = shows.slice(0, 9);
    const rows = [];
    for (let i = 0; i < top9.length; i = i + 3, i) {
      rows.push(top9.slice(i, i + 3));
    }
    t2 = <>{rows.map((row, ri) => <div key={ri} className={`grid grid-cols-3 gap-[6px] px-4${ri > 0 ? " mt-[6px]" : ""}`}>{row.map((show, i_0) => {
          const contentOrder = ri * 3 + i_0;
          const rank = contentOrder + 1;
          return <MostWatchedCard key={i_0} show={show} rank={rank} showRank={showRank} onClick={onClick} analyticsMeta={analytics ? {
            content_name: show.title,
            screen_name: "Home",
            placement_tab: analytics.placement_tab,
            widget_title: analytics.widget_title,
            widget_type: analytics.widget_type,
            widget_order: analytics.widget_order,
            content_order: contentOrder
          } : undefined} />;
        })}</div>)}</>;
    $[0] = analytics;
    $[1] = onClick;
    $[2] = showRank;
    $[3] = shows;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}

// Figma node 1824:7158 — ₹1 unlock banner
function UnlockBanner(t0) {
  const $ = _c(11);
  const {
    onClick,
    screenName
  } = t0;
  const bannerRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== screenName) {
    t1 = () => {
      if (!screenName) {
        return;
      }
      const key = screenName;
      if (nudgeImpressionsSeen.has(key)) {
        return;
      }
      const el = bannerRef.current;
      if (!el) {
        return;
      }
      const observer = new IntersectionObserver(t3 => {
        const [entry] = t3;
        if (entry.isIntersecting && !nudgeImpressionsSeen.has(key)) {
          nudgeImpressionsSeen.add(key);
          trackAnalyticsEvent("FREE_TRIAL_NUDGE_VIEWED_WEB", {
            screen_name: key
          });
          observer.disconnect();
        }
      }, {
        threshold: 0.5
      });
      observer.observe(el);
      return () => observer.disconnect();
    };
    t2 = [screenName];
    $[0] = screenName;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== onClick || $[4] !== screenName) {
    t3 = () => {
      if (screenName) {
        trackAnalyticsEvent("FREE_TRIAL_NUDGE_CTA_CLICKED_WEB", {
          screen_name: screenName
        });
      }
      onClick();
    };
    $[3] = onClick;
    $[4] = screenName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleCtaClick = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      background: "linear-gradient(157.46deg, rgba(255,171,13,0.2) 5.22%, rgba(255,255,255,0) 97.31%)"
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex flex-col gap-[6px]"><p className="text-white font-semibold text-[32px] leading-[1.5]">Unlock for <span className="text-[#ffba27]">₹1</span> Today</p><p className="text-[#a0a0ab] text-[12px] leading-[18px]">Enjoy 24-hour free unlimited access!</p></div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      background: "linear-gradient(180deg, #ffba27 18%, #ffa700 97%)"
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== handleCtaClick) {
    t7 = <div ref={bannerRef} className="px-4 mb-4"><div className="w-full rounded-[12px] border border-white/20 backdrop-blur-[2px] px-[12px] py-[24px] flex flex-col gap-[24px]" style={t4}>{t5}<button onClick={handleCtaClick} className="self-start px-[12px] py-[8px] rounded-[8px] text-black text-[12px] font-semibold" style={t6}>Upgrade Plan</button></div></div>;
    $[9] = handleCtaClick;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}

// MockAppUI is only rendered after a client-side popstate transition —
// document.body is guaranteed to exist, no mounted guard needed.
export function MockAppUI(t0) {
  const $ = _c(71);
  const {
    onThumbnailClick
  } = t0;
  const [activeTab, setActiveTab] = useState(currentTab);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = tab => {
      setActiveTab(tab);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const changeTab = t1;
  const swipeTouchStart = useRef(null);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      swipeTouchStart.current = {
        x: e.touches[0].clientX,
        y: e.touches[0].clientY
      };
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleSwipeTouchStart = t2;
  let t3;
  if ($[2] !== activeTab) {
    t3 = e_0 => {
      if (!swipeTouchStart.current) {
        return;
      }
      const dx = e_0.changedTouches[0].clientX - swipeTouchStart.current.x;
      const dy = e_0.changedTouches[0].clientY - swipeTouchStart.current.y;
      swipeTouchStart.current = null;
      if (Math.abs(dx) <= Math.abs(dy)) {
        return;
      }
      if (Math.abs(dx) < 50) {
        return;
      }
      if (dx < 0 && activeTab < TAB_LABELS.length - 1) {
        changeTab(activeTab + 1);
      } else {
        if (dx > 0 && activeTab > 0) {
          changeTab(activeTab - 1);
        }
      }
    };
    $[2] = activeTab;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleSwipeTouchEnd = t3;
  let t4;
  let t5;
  if ($[4] !== activeTab) {
    t4 = () => {
      currentTab = activeTab;
      return _temp;
    };
    t5 = [activeTab];
    $[4] = activeTab;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[7] !== activeTab) {
    t6 = () => {
      sessionStorage.setItem("alright_entry_source", SCREEN_NAMES[activeTab]);
    };
    t7 = [activeTab];
    $[7] = activeTab;
    $[8] = t6;
    $[9] = t7;
  } else {
    t6 = $[8];
    t7 = $[9];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[10] !== activeTab) {
    t8 = () => {
      const screenName = SCREEN_NAMES[activeTab];
      if (lastScreenName === screenName) {
        return;
      }
      trackAnalyticsEvent("SCREEN_VIEWED_WEB", {
        screen_name: screenName,
        entry_source: lastScreenName
      });
      lastScreenName = screenName;
    };
    t9 = [activeTab];
    $[10] = activeTab;
    $[11] = t8;
    $[12] = t9;
  } else {
    t8 = $[11];
    t9 = $[12];
  }
  useEffect(t8, t9);
  const contentRef = useRef(null);
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      spotlightH: 320,
      gridCardW: 107,
      gridCardH: 160,
      contentWidth: 375
    };
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const [dims, setDims] = useState(t10);
  let t11;
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => {
      const el = contentRef.current;
      if (!el) {
        return;
      }
      const compute = () => {
        const availableH = el.clientHeight;
        const availableW = el.clientWidth;
        const gridCardW = (availableW - 44) / 3;
        const gridCardH = gridCardW * 1.5;
        const spotlightH = availableH - 26 - gridCardH;
        setDims({
          spotlightH: Math.max(spotlightH, 120),
          gridCardW,
          gridCardH,
          contentWidth: availableW
        });
      };
      compute();
      const ro = new ResizeObserver(compute);
      ro.observe(el);
      return () => ro.disconnect();
    };
    t12 = [];
    $[14] = t11;
    $[15] = t12;
  } else {
    t11 = $[14];
    t12 = $[15];
  }
  useLayoutEffect(t11, t12);
  const currentPlacementTab = TAB_LABELS[activeTab];
  const currentScreenName = SCREEN_NAMES[activeTab];
  let t13;
  if ($[16] !== onThumbnailClick) {
    t13 = source => {
      if (source) {
        sessionStorage.setItem("alright_entry_source", source);
      }
      onThumbnailClick();
    };
    $[16] = onThumbnailClick;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  const handleNavigate = t13;
  let t14;
  if ($[18] !== handleNavigate) {
    t14 = () => {
      trackAnalyticsEvent("SEARCH_BUTTON_CLICKED_WEB");
      handleNavigate("search");
    };
    $[18] = handleNavigate;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  let t16;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <svg className="w-4 h-4 text-[#808083] flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    t16 = <span className="text-[#808083] text-[13px]">Search</span>;
    $[20] = t15;
    $[21] = t16;
  } else {
    t15 = $[20];
    t16 = $[21];
  }
  let t17;
  if ($[22] !== t14) {
    t17 = <div onClick={t14} className="flex-1 flex items-center bg-[#2a2a2e] rounded-full px-3 py-[7px] gap-2 cursor-pointer">{t15}{t16}</div>;
    $[22] = t14;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== handleNavigate) {
    t18 = () => {
      trackAnalyticsEvent("PROFILE_BUTTON_CLICKED_WEB");
      handleNavigate("profile");
    };
    $[24] = handleNavigate;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M5.72444 26.9076C6.63693 24.7578 8.76738 23.25 11.25 23.25H20.25C22.7326 23.25 24.8631 24.7578 25.7756 26.9076M21.75 12C21.75 15.3137 19.0637 18 15.75 18C12.4363 18 9.75 15.3137 9.75 12C9.75 8.68629 12.4363 6 15.75 6C19.0637 6 21.75 8.68629 21.75 12ZM30.75 15.75C30.75 24.0343 24.0343 30.75 15.75 30.75C7.46573 30.75 0.75 24.0343 0.75 15.75C0.75 7.46573 7.46573 0.75 15.75 0.75C24.0343 0.75 30.75 7.46573 30.75 15.75Z" stroke="#A0A0AB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== t18) {
    t20 = <div onClick={t18} className="w-8 h-8 rounded-full bg-[#2a2a2e] flex items-center justify-center flex-shrink-0 cursor-pointer">{t19}</div>;
    $[27] = t18;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== t17 || $[30] !== t20) {
    t21 = <div className="flex-shrink-0 flex items-center gap-3 px-4 py-3">{t17}{t20}</div>;
    $[29] = t17;
    $[30] = t20;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== activeTab) {
    t22 = TAB_LABELS.map((tab_0, i) => <button key={tab_0} onClick={() => changeTab(i)} className={`flex-1 py-2 text-[13px] font-medium border-b-2 transition-colors text-center ${i === activeTab ? "border-[#FFAF00] text-[#FFAF00]" : "border-transparent text-[#808083]"}`}>{tab_0}</button>);
    $[32] = activeTab;
    $[33] = t22;
  } else {
    t22 = $[33];
  }
  let t23;
  if ($[34] !== t22) {
    t23 = <div className="flex-shrink-0 flex border-b border-white/10">{t22}</div>;
    $[34] = t22;
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] !== activeTab || $[37] !== currentPlacementTab || $[38] !== currentScreenName || $[39] !== dims || $[40] !== handleNavigate) {
    t24 = activeTab === 0 && <><SpotlightCarousel shows={SPOTLIGHT} onActiveClick={handleNavigate} containerHeight={dims.spotlightH} contentWidth={dims.contentWidth} analytics={{
        placement_tab: currentPlacementTab,
        widget_title: "Spotlight",
        widget_type: "spotlight",
        widget_order: 0
      }} /><div className="mb-4"><SectionHeader title="Recommended For You" /><ShowGrid shows={RECOMMENDED} onClick={handleNavigate} analytics={{
          placement_tab: currentPlacementTab,
          widget_title: "RECOMMENDED FOR YOU",
          widget_type: "horizontal",
          widget_order: 1
        }} /></div><div className="mb-4"><SectionHeader title="Most Watched in India" /><MostWatchedGrid shows={MOST_WATCHED} onClick={handleNavigate} analytics={{
          placement_tab: currentPlacementTab,
          widget_title: "TRENDING TOP 10",
          widget_type: "horizontal",
          widget_order: 2
        }} /></div><UnlockBanner onClick={handleNavigate} screenName={currentScreenName} /></>;
    $[36] = activeTab;
    $[37] = currentPlacementTab;
    $[38] = currentScreenName;
    $[39] = dims;
    $[40] = handleNavigate;
    $[41] = t24;
  } else {
    t24 = $[41];
  }
  let t25;
  if ($[42] !== activeTab || $[43] !== currentPlacementTab || $[44] !== currentScreenName || $[45] !== handleNavigate) {
    t25 = activeTab === 1 && <><div className="pt-4 mb-4"><MostWatchedGrid shows={MOST_WATCHED} onClick={handleNavigate} analytics={{
          placement_tab: currentPlacementTab,
          widget_title: "TRENDING TOP 10",
          widget_type: "horizontal",
          widget_order: 0
        }} /></div><UnlockBanner onClick={handleNavigate} screenName={currentScreenName} /><div className="mb-4"><SectionHeader title="New Releases" /><MostWatchedGrid shows={NEW_RELEASES} onClick={handleNavigate} showRank={false} analytics={{
          placement_tab: currentPlacementTab,
          widget_title: "New Releases",
          widget_type: "horizontal",
          widget_order: 1
        }} /></div></>;
    $[42] = activeTab;
    $[43] = currentPlacementTab;
    $[44] = currentScreenName;
    $[45] = handleNavigate;
    $[46] = t25;
  } else {
    t25 = $[46];
  }
  let t26;
  if ($[47] !== activeTab || $[48] !== currentPlacementTab || $[49] !== currentScreenName || $[50] !== handleNavigate) {
    t26 = activeTab === 2 && <><div className="mb-4 pt-4"><MostWatchedGrid shows={PREMIUM_ORIGINALS} onClick={handleNavigate} showRank={false} analytics={{
          placement_tab: currentPlacementTab,
          widget_title: "TRENDING TOP 10",
          widget_type: "horizontal",
          widget_order: 0
        }} /></div><UnlockBanner onClick={handleNavigate} screenName={currentScreenName} /><div className="mb-4"><SectionHeader title="New Releases" /><MostWatchedGrid shows={NEW_RELEASES} onClick={handleNavigate} showRank={false} analytics={{
          placement_tab: currentPlacementTab,
          widget_title: "New Releases",
          widget_type: "horizontal",
          widget_order: 1
        }} /></div></>;
    $[47] = activeTab;
    $[48] = currentPlacementTab;
    $[49] = currentScreenName;
    $[50] = handleNavigate;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] !== activeTab || $[53] !== currentPlacementTab || $[54] !== currentScreenName || $[55] !== handleNavigate) {
    t27 = activeTab === 3 && <><div className="mb-4 pt-4"><MostWatchedGrid shows={GLOBAL_SHOWS} onClick={handleNavigate} showRank={false} analytics={{
          placement_tab: currentPlacementTab,
          widget_title: "Globally Loved Stories",
          widget_type: "horizontal",
          widget_order: 0
        }} /></div><UnlockBanner onClick={handleNavigate} screenName={currentScreenName} /><div className="mb-4"><SectionHeader title="New Releases" /><MostWatchedGrid shows={NEW_RELEASES} onClick={handleNavigate} showRank={false} analytics={{
          placement_tab: currentPlacementTab,
          widget_title: "New Releases",
          widget_type: "horizontal",
          widget_order: 1
        }} /></div></>;
    $[52] = activeTab;
    $[53] = currentPlacementTab;
    $[54] = currentScreenName;
    $[55] = handleNavigate;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <div className="h-4" />;
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  let t29;
  if ($[58] !== handleSwipeTouchEnd || $[59] !== t24 || $[60] !== t25 || $[61] !== t26 || $[62] !== t27) {
    t29 = <div ref={contentRef} className="flex-1 overflow-y-auto overscroll-contain [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" onTouchStart={handleSwipeTouchStart} onTouchEnd={handleSwipeTouchEnd}>{t24}{t25}{t26}{t27}{t28}</div>;
    $[58] = handleSwipeTouchEnd;
    $[59] = t24;
    $[60] = t25;
    $[61] = t26;
    $[62] = t27;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  let t30;
  if ($[64] !== handleNavigate) {
    t30 = <BottomNavbar onTap={handleNavigate} />;
    $[64] = handleNavigate;
    $[65] = t30;
  } else {
    t30 = $[65];
  }
  let t31;
  if ($[66] !== t21 || $[67] !== t23 || $[68] !== t29 || $[69] !== t30) {
    const ui = <div className="fixed inset-0 z-[100] bg-[#131316] flex flex-col">{t21}{t23}{t29}{t30}</div>;
    t31 = createPortal(ui, document.body);
    $[66] = t21;
    $[67] = t23;
    $[68] = t29;
    $[69] = t30;
    $[70] = t31;
  } else {
    t31 = $[70];
  }
  return t31;
}
function _temp() {
  currentTab = 0;
}